function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5674 13.915C13.5362 13.915 14.1918 13.9835 14.286 13.9941C14.8117 14.0525 15.2092 14.4967 15.2092 15.0255V16.2753L19.1052 12.3211L15.2092 8.36672V9.61651C15.2092 10.1897 14.7445 10.6543 14.1713 10.6543C10.9859 10.6543 8.52262 11.5056 6.84963 13.1849C6.0876 13.9498 5.57025 14.8034 5.21868 15.61C7.6371 14.1729 10.6899 13.915 12.5674 13.915ZM3.438 19.8455C3.35134 19.8455 3.26364 19.8346 3.17646 19.8117C2.72059 19.6932 2.40172 19.2824 2.40016 18.8113C2.39938 18.6444 2.41884 14.6913 5.37927 11.7197C7.26061 9.8311 9.8656 8.78624 13.1335 8.6067V5.83464C13.1335 5.41354 13.388 5.03394 13.7777 4.87437C14.168 4.71454 14.615 4.80614 14.9105 5.10634L21.3015 11.5926C21.6995 11.9968 21.6995 12.6455 21.3015 13.0494L14.9105 19.5357C14.615 19.8356 14.168 19.9277 13.7777 19.7676C13.388 19.608 13.1335 19.2285 13.1335 18.8074V16.0034C11.0698 15.9447 6.1247 16.1508 4.34221 19.3167C4.15514 19.6488 3.80591 19.8455 3.438 19.8455Z",
  fill: "#4E597B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19.2,
  height: 15.0486,
  fill: "white",
  transform: "translate(2.40002 4.8)"
})));

var SvgIconShare = function SvgIconShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_share.4189bd33.svg";
export { ForwardRef as ReactComponent };